export default "/images/vendor/flag-icons/flags/4x3/au.svg?fdaebf2b3a87f4cbd2fbdf58fc0a9eb2";